import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { OverviewTab } from './OverviewTab';
import { EngagementTab } from './EngagementTab';
import { HealthTab } from './HealthTab';
import { UsersTab } from './UsersTab';

export function AnalyticsDashboard() {
  // Drill-from-Health-tab to Users-tab is hand-wired through this state
  // so an admin clicking a "near burn cap" user lands on the Users tab
  // with the userId pre-filled.
  const [activeTab, setActiveTab] = useState<string>('overview');
  const [drilledUserId, setDrilledUserId] = useState<string | undefined>(undefined);

  function handleDrillToUser(userId: string) {
    setDrilledUserId(userId);
    setActiveTab('users');
  }

  return (
    <div className="max-w-7xl mx-auto p-8">
      <Link
        to="/dev-console"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-4"
      >
        <ArrowLeft className="h-4 w-4" /> Back to Dev Console
      </Link>

      <h1 className="text-2xl font-bold text-foreground mb-2">Platform Usage</h1>
      <p className="text-sm text-muted-foreground mb-6">
        Global usage analytics — DAU/MAU, where users spend their time and credits, system health,
        and per-user drill-down.
      </p>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-6">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="engagement">Engagement</TabsTrigger>
          <TabsTrigger value="health">Health</TabsTrigger>
          <TabsTrigger value="users">Users</TabsTrigger>
        </TabsList>

        <TabsContent value="overview">
          <OverviewTab />
        </TabsContent>
        <TabsContent value="engagement">
          <EngagementTab />
        </TabsContent>
        <TabsContent value="health">
          <HealthTab onDrillToUser={handleDrillToUser} />
        </TabsContent>
        <TabsContent value="users">
          <UsersTab initialUserId={drilledUserId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
